module.exports = __webpack_public_path__ + "img/cmg1.ad3f51a1.png";